import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import axios from 'axios';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const printNewSalesInvoice = async (orderId) => {
  const accessToken = localStorage.getItem('accessToken');
  const formData = new FormData();
  formData.set('orderId', orderId);
  const apiUrl = `${config.API_URL}/ws-new-sales-details`;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;  
  };

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    const data = response.data;
    console.log(data);

    if (!data.success || !data.details.orderDetails || data.details.orderDetails.length === 0) {
      console.error("No order details found in the response.");
      return;  
    }

    const orderDetails = data.details.orderDetails[0];  
    const shopDetails = data.details.shop_details;
    console.log(orderDetails);
    

    // Separate calculations for contract vs non-contract products

// WITHOUT CONTRACT PRODUCTS
const totalstd_without_contract = data.details.product_details
    .filter(item => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === 'N')
    .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

const totalzeroGoods_without_contract = data.details.product_details
    .filter(item => (item.item_tax === "0.00" || item.item_tax === null) && item.isContractPriceApplied === 'N')
    .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

const totalTax_without_contract = data.details.product_details
    .filter(item => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === 'N')
    .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

// WITH CONTRACT PRODUCTS
const totalstd_with_contract = data.details.product_details
    .filter(item => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === 'Y')
    .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

const totalzeroGoods_with_contract = data.details.product_details
    .filter(item => (item.item_tax === "0.00" || item.item_tax === null) && item.isContractPriceApplied === 'Y')
    .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

const totalTax_with_contract = data.details.product_details
    .filter(item => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === 'Y')
    .reduce((sum, item) => sum + parseFloat(item.item_tax), 0);

// COMBINE TOTALS
const totalstd = totalstd_without_contract + totalstd_with_contract;
const totalzeroGoods = totalzeroGoods_without_contract + totalzeroGoods_with_contract;

// GET DISCOUNT VALUES
const orderDiscount = parseFloat(data.details.orderDetails[0].order_discount) || 0;
const orderDiscount1 = parseFloat(data.details.orderDetails[0].order_discount1) || 0;
const over_all_discount = parseFloat(data.details.orderDetails[0].over_all_discount) || 0;
const over_all_amount = parseFloat(data.details.orderDetails[0].over_all_amount) || 0;
const percentage = parseFloat(data.details.orderDetails[0].percentage) || 0;

// CALCULATE TOTAL DISCOUNT PERCENTAGE (only applies to non-contract items)
let totalDiscountOnVat = 0;
if (over_all_discount > 0) {
    totalDiscountOnVat += over_all_discount;
}
if (percentage > 0) {
    totalDiscountOnVat += percentage;
}

// APPLY VAT DISCOUNT ONLY TO NON-CONTRACT VAT
const discountedVatWithoutContract = totalTax_without_contract - ((totalTax_without_contract * totalDiscountOnVat) / 100);
const totalVAT = discountedVatWithoutContract + totalTax_with_contract;

// CALCULATE INVOICE DISCOUNT (only applies to non-contract products)
const totalWithoutContract = totalzeroGoods_without_contract + totalstd_without_contract;
let InvDiscount = 0;
if (over_all_discount > 0) {
    InvDiscount = (totalWithoutContract * over_all_discount) / 100;
}

// FINAL CALCULATIONS
const itemTotal = totalstd + totalzeroGoods;
const totalAmount = totalstd + totalzeroGoods + totalVAT - over_all_amount - orderDiscount1;

// SUMMARY OBJECT (optional - for easy access to all values)
const calculationSummary = {
    withoutContract: {
        standardGoods: totalstd_without_contract,
        zeroTaxGoods: totalzeroGoods_without_contract,
        tax: totalTax_without_contract,
        discountedTax: discountedVatWithoutContract,
        subtotal: totalWithoutContract,
        invoiceDiscount: InvDiscount
    },
    withContract: {
        standardGoods: totalstd_with_contract,
        zeroTaxGoods: totalzeroGoods_with_contract,
        tax: totalTax_with_contract,
        subtotal: totalstd_with_contract + totalzeroGoods_with_contract
    },
    totals: {
        standardGoods: totalstd,
        zeroTaxGoods: totalzeroGoods,
        vat: totalVAT,
        itemTotal: itemTotal,
        finalAmount: totalAmount,
        discountPercentage: totalDiscountOnVat
    }
};

console.log('Calculation Summary:', calculationSummary);
    const doc = new jsPDF('portrait'); // Set to portrait orientation
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 5;  // 5px padding
    let y = margin;
    const firstColumnWidth = pageWidth * 0.25;  // 30% of the page width
    const secondColumnWidth = pageWidth * 0.75; 
    const H2firstColumnWidth = pageWidth * 0.30; 

    // Add the logo image to the header (make sure the image path is correct)
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`; // Path to the logo image
    const logoWidth = 40; // Width of the logo in the PDF (adjust as needed)
    const logoHeight = 15; // Height of the logo (adjust as needed)
    doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight); // Adds the logo at the top-left corner
    y += logoHeight + 5; // Adjust y position after adding the logo

    // Now create the other sections of the header
    const headerSections2 = [
      [
    // Add shop details (below logo)
        ],
      [
        { text: `${shopDetails.shop_name}`, size: 13, bold: true },

        {
          text: `${shopDetails.address.split(' ').slice(0, Math.ceil(shopDetails.address.split(' ').length / 2)).join(' ')}\n${shopDetails.address.split(' ').slice(Math.ceil(shopDetails.address.split(' ').length / 2)).join(' ')}`,
          size: 8,
          bold: false

        },
        { text: ``, size: 8, bold: false },
        { text: ``, size: 8, bold: false },
        { text: `Phone No : ${shopDetails.phone} | Email : ${shopDetails.email}`, size: 8, bold: false, margin: [0, 5, 0, 5] },
        { text: `Website : ${shopDetails.website}`, size: 8, bold: false, margin: [0, 5, 0, 5] },
        { text: `Company No : ${shopDetails.company_reg_no} | VAT No : ${shopDetails.vat_no}`, size: 8, bold: false, margin: [0, 5, 0, 5] },
        ],
      ];


    const headerSections3 = [
      [

        { text: `${orderDetails.company}`, size: 11, bold: true },
        {
          text: `${orderDetails.address.split(' ').slice(0, Math.ceil(orderDetails.address.split(' ').length / 2)).join(' ')}\n${orderDetails.address.split(' ').slice(Math.ceil(orderDetails.address.split(' ').length / 2)).join(' ')}`,
          size: 8,
          bold: false

        }, 
        { text: ``, size: 8, bold: false },
        { text: `${orderDetails.city} ,${orderDetails.postal_code}`, size: 8, bold: false },
        { text: `Phone No : ${orderDetails.phone}`, size: 8, bold: false },
        { text: `Email Id : ${orderDetails.email}`, size: 8, bold: false },
        ],
      
      [
        { text: ``, size: 8, bold: false },
        { text: `Invoice No : ${orderDetails.reference_no}`, size: 8, bold: false },
        { text: `Order Date: ${formatDate(orderDetails.date)}`, size: 8, bold: false },
        { text: `Account No: ${orderDetails.account_no}`, size: 8, bold: false },
        ],
      ];

    const sectionWidth = (pageWidth - margin * 2) / 2; // Adjust for margins

    // Render header sections
    y = 7;
    const renderSections = (sections) => {
      sections.forEach((section, index) => {
        //const colStartX = margin + (index % 3) * sectionWidth;
        const colStartX = margin + (index % 2) * firstColumnWidth;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 4); // Reduced space between lines
        });

        if (index % 4 === 3) {
          y += 12; // Reduced spacing after every 4 sections
        }
      });
      y += 25; // Add a little space after the last header section
    };
    const h2renderSections = (sections) => {
      sections.forEach((section, index) => {
        //const colStartX = margin + (index % 3) * sectionWidth;
        const colStartX = margin + (index % 2) * H2firstColumnWidth;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 4); // Reduced space between lines
        });

        if (index % 4 === 3) {
          y += 12; // Reduced spacing after every 4 sections
        }
      });
      y += 25; // Add a little space after the last header section
    };

    
    renderSections(headerSections2);
    h2renderSections(headerSections3);
    // Render table columns with customized widths
    const tableColumns = [
      { title: 'Product', dataKey: 'product', size: 6, bold: false },
      { title: 'Order Type', dataKey: 'order_type', size: 6, bold: false },
      { title: 'Qty', dataKey: 'qty', size: 6, bold: false },
      { title: 'Unit Price', dataKey: 'unit_price', size: 6, bold: false },
      { title: 'Discount', dataKey: 'discount', size: 6, bold: false },
      { title: 'VAT', dataKey: 'vat', size: 6, bold: false },
      { title: 'Net Amount', dataKey: 'net_amount', size: 6, bold: false },
      ];

    // Calculate the table widths
    const totalWidth = pageWidth - 2 * margin;
    const productWidth = totalWidth * 0.45;  
    const orderTypeWidth = totalWidth * 0.06;  
    const qtyWidth = totalWidth * 0.06; 
    const unitPriceWidth = totalWidth * 0.12;  
    const discountWidth = totalWidth * 0.08;  
    const vatWidth = totalWidth * 0.11; 
    const netAmountWidth = totalWidth * 0.12; 



    const tableBody = data.details.product_details.map((item) => [
      // Remove promo_product, free_product, ContractPrice from the product description
      item.product_code + ' - ' + item.product_name + ' - ' + item.size+ item.promo_product+ item.free_product+ item.ContractPrice , 
      item.order_type,
      parseInt(item.quantity),   
      '£ ' + parseFloat(item.unit_price).toFixed(2), 
      '£ ' +  parseFloat(item.item_discount).toFixed(2),  
      '£ ' + parseFloat(item.item_tax).toFixed(2), 
      '£ ' + parseFloat(item.subtotal).toFixed(2), 
      ]);

    // Add an empty row with totals
    tableBody.push([
      { content: 'Item Total:', colSpan: 6, styles: { halign: 'right' } },
      {content : `£ ${itemTotal.toFixed(2)}`} 
      
      ]);

    tableBody.push([
      { content: `NON VAT Goods - £ ${totalzeroGoods.toFixed(2)}  | VAT Goods - £ ${totalstd.toFixed(2)}`, colSpan: 5, styles: { halign: 'left' } }, 
      { content: 'Total Vat:',  styles: { halign: 'right' } }, 
      {content : `£ ${totalVAT.toFixed(2)}` }

      ]);


    tableBody.push([
      { content: `Order Discount(${over_all_discount}%)`, colSpan: 6, styles: { halign: 'right' } }, 
      over_all_amount.toFixed(2)
      ]);

 tableBody.push([
      { content: `Promo Discount`, colSpan: 6, styles: { halign: 'right' } }, 
      orderDiscount1.toFixed(2)
      ]);

    tableBody.push([
      { content: 'Total Amount:', colSpan: 6, styles: { halign: 'right' } }, 
      {content : `£ ${totalAmount.toFixed(2)}` }
      ]);



    doc.autoTable({
      startY: y,
      head: [tableColumns.map(col => col.title)],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: '#f8f9fa',
        textColor: '#404040',
        fontSize: 8,  // Ensure font size 6 for table header
        valign: 'middle', // Center-align vertically if needed
      },
      bodyStyles: {
        fontSize: 8,  // Ensure font size 6 for table body rows
        valign: 'middle', // Center-align vertically in rows
      },
      margin: { top: 0, left: margin, right: margin },

      columnStyles: {
        0: { cellWidth: productWidth },
        1: { cellWidth: orderTypeWidth },
        2: { cellWidth: qtyWidth },
        3: { cellWidth: unitPriceWidth },
        4: { cellWidth: discountWidth },
        5: { cellWidth: vatWidth },
        6: { cellWidth: netAmountWidth },
        1: { halign: 'center' },
        2: { halign: 'center' },
        3: { halign: 'right' },
        4: { halign: 'center' },
        5: { halign: 'right' },
        6: { halign: 'right' },
      },

    });

    


    y = doc.autoTable.previous.finalY + 5; // Y position after table
    const addPageNumbers = (doc) => {
      const pageCount = doc.internal.getNumberOfPages(); // Get total number of pages
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
  
      for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i); // Go to the specific page
          doc.setFontSize(8); // Set font size for page numbers
          doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: 'center' }); // Add page number at the bottom center
      }
  };
    const addFooterSection = (footerSection) => {
      footerSection.forEach((section, index) => {
        const colStartX = margin + (index % 4) * sectionWidth;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 5);
        });

        if (index % 4 === 3) {
          y += 20; // Move down after every 4 sections
        }
      });
      y += 60; // Add space after each footer section
    };

    const addFooterWithSpaceCheck = (footerSection) => {
      const remainingSpace = pageHeight - y - margin; // Remaining space on the page
      const requiredSpace = footerSection.length * 5 + 20; // Space needed

      if (remainingSpace < requiredSpace) {
        doc.addPage(); // Add a new page if not enough space
        y = margin; // Reset Y position for new page
      }

      addFooterSection(footerSection);
    };

    const footerSections2 = [
      [
        { text: 'Good Received & Checked By : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ No of Boxes Received : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _', size: 8, bold: false },
        { text: '', size: 8, bold: false },
        { text: 'Amount Paid : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ Cash / Cheque Collected By : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _', size: 8, bold: false },
        { text: 'Bank Details', size: 9, bold: false },
        { text: `A/C No : ${shopDetails.bank_ac}  |  Sort Code : ${shopDetails.sort_code}`, size: 9, bold: false },
        { text: 'Terms -', size: 8, bold: false },
        { text: `1 - Once delivery is received ${shopDetails.shop_name} is not responsible for any damage or loss `, size: 8, bold: false },
        { text: `2 - Goods remain the property of ${shopDetails.shop_name} until invoice fully paid `, size: 8, bold: false },
        { text: `3 - No claims for damages or short delivery will be considered unless made at the time of delivery of goods.`, size: 8, bold: false },
        { text: `4 - There is No Refund Policy Of goods sold`, size: 8, bold: false },
      ]
      ];

    addFooterWithSpaceCheck(footerSections2);

    const footerSections3 = [
      [
        { text: `Note: ${orderDetails.staff_note}`, size: 8, bold: true },
      ]
    ];

    addFooterWithSpaceCheck(footerSections3);
    addPageNumbers(doc);
    const filename = generateUniqueFilename('Invoice', 'pdf');
    doc.save(filename);
    doc.autoPrint();
    window.open(doc.output('bloburl'));

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default printNewSalesInvoice;
